import React, {
    useEffect, useRef,
    // useMemo,
} from "react";
import { useResizeDetector } from "react-resize-detector";
import {
    MenuTopLeft, MenuLeft,
} from "../Menu";
import Sidebar from "./Sidebar";
import Statusbar from "./Statusbar";
import GridLayout from "./GridLayout";
import Selection from "./Selection";
import TabBar from "./TabBar";
import Tabs from "./Tabs";
import useStore from "../../store";
import Dialog from "./Dialog";
import NotificationCenter from "./NotificationCenter";

/* eslint-disable-next-line no-undef */
const onBrowser = _isBrowser;

export default function Dashboard() {
    const dashboardSelectionOpen = useStore((store) => store.dashboard.dashboardSelectionOpen);

    const statusBarHeight = 21;

    const contentRef = useRef();
    const sidebarRef = useRef();
    const { width: menuWidth, ref: menuRef } = useResizeDetector();

    useEffect(() => {
        setTimeout(() => window.dispatchEvent(new Event("resize")), 0);
    }, [menuWidth]);

    return (
        <div style={{
            display: "flex",
            // height: `calc(100% - ${statusBarHeight}px)`,
            height: "100%",
        }}
        >
            <div ref={menuRef}>
                <MenuTopLeft />
                <MenuLeft />
            </div>
            <div style={{
                flexGrow: 1,
                height: "100%",
                overflow: "hidden",
            }}
            >
                <TabBar />

                {dashboardSelectionOpen ? <Selection /> : null}
                <div
                    id="dashboardDialogContent"
                    ref={contentRef}
                    style={{
                        position: "relative",
                        overflow: "auto",
                        height: `calc(100% - ${onBrowser ? "30px" : "40px"}${dashboardSelectionOpen ? " - 25px" : ""} - 21px)`,
                        width: "100%",
                    }}
                >
                    <NotificationCenter />
                    <Dialog />
                    {/* {useMemo(() => ( */}
                    <Tabs />
                    {/* ), [])} */}
                </div>

                <div style={{
                    display: "flex",
                    height: statusBarHeight,
                    borderTop: "1px solid",
                }}
                >
                    <Statusbar
                        contentRef={contentRef}
                        sidebarRef={sidebarRef}
                    />
                </div>
            </div>
            <Sidebar side="right">
                <div
                    ref={sidebarRef}
                    style={{
                        overflow: "auto",
                        height: "100%",
                        width: "100%",
                    }}
                >
                    {/* {useMemo(() => ( */}
                    <GridLayout
                        section="right"
                        cols="5"
                    />
                    {/* ), [])} */}
                </div>
            </Sidebar>
        </div>
    );
}
